export const getScreenerFriendlyPhoneNumber = phoneNumber =>
    phoneNumber.replace(/(\d)/g, '$& ').trim();
